export const defaultImport = (mod)=>{
    if (typeof mod !== 'object' || mod === null) {
        return mod;
    }
    const defaultVal = Symbol.toStringTag in mod && mod[Symbol.toStringTag] === 'Module' ? mod.default ?? mod : mod;
    if (typeof defaultVal === 'object' && '__esModule' in defaultVal && defaultVal.__esModule && defaultVal.default !== undefined) {
        return defaultVal.default;
    }
    return defaultVal;
};

//# sourceMappingURL=default-import.js.map